import { Injectable, inject } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { from, of } from 'rxjs'
import { catchError, concatMap, map, switchMap, tap } from 'rxjs/operators'
import { BuyersGroupApiService } from 'src/pages/admin/settings/buyers-groups/buyers-groups-item/buyers-groups.service'
import { ToasterService } from 'src/shared/toaster/toaster.service'
import { catchAndLog } from 'src/shared/utils/catch-and-log'
import { createBuyersGroup, createBuyersGroupFailure, createBuyersGroupSuccess, deleteBuyersGroup, deleteBuyersGroupFailure, deleteBuyersGroupSuccess, loadBuyersGroups, loadBuyersGroupsFailure, loadBuyersGroupsSuccess, updateBuyersGroup, updateBuyersGroupFailure, updateBuyersGroupSuccess } from './buyers-group.actions'

@Injectable()
export class BuyersGroupEffects {
  private actions$ = inject(Actions)
  private BuyersGroupApi = inject(BuyersGroupApiService)
  private toaster = inject(ToasterService)


  loadBuyersGroups$ = createEffect(() => this.actions$.pipe(
    ofType(loadBuyersGroups),
    switchMap(() =>
      from(this.BuyersGroupApi.list()).pipe(
        map(buyersGroups => loadBuyersGroupsSuccess({ buyersGroups })),
        catchAndLog(this.toaster, 'Unable to fetch buyersGroups', loadBuyersGroupsFailure)))))

  createBuyersGroup$ = createEffect(() => this.actions$.pipe(
    ofType(createBuyersGroup),
    tap(() => this.toaster.progress('Creating buyers group...')),
    switchMap(action =>
      from(this.BuyersGroupApi.create(action.buyersGroup)).pipe(
        map(({ data: buyersGroup}) => createBuyersGroupSuccess({ buyersGroup })),
        tap(() => this.toaster.success('Buyers Group created successfully.')),
        catchAndLog(this.toaster, 'Unable to create buyersGroup', createBuyersGroupFailure)))))

  updateBuyersGroup$ = createEffect(() => this.actions$.pipe(
    ofType(updateBuyersGroup),
    tap(() => this.toaster.progress('Updating buyers group...')),
    concatMap(action =>
      from(this.BuyersGroupApi.update({ group_id: action.id, ...action.buyersGroup })).pipe(
        map(({ data: buyersGroup}) => updateBuyersGroupSuccess({ buyersGroup })),
        tap(() => this.toaster.success('Buyers Group updated successfully.')),
        catchError(err => {
          this.toaster.error('Unable to update buyers group')
          return of(updateBuyersGroupFailure({ error: err, id: action.id }))
        })))))

  deleteBuyersGroup$ = createEffect(() => this.actions$.pipe(
    ofType(deleteBuyersGroup),
    tap(() => this.toaster.progress('Deleting buyers group...')),
    switchMap(action =>
      from(this.BuyersGroupApi.delete(action.id)).pipe(
        map(() => deleteBuyersGroupSuccess({ id: action.id })),
        tap(() => this.toaster.success('Buyers Group deleted successfully.')),
        catchAndLog(this.toaster, 'Unable to delete buyersGroup', deleteBuyersGroupFailure)))))
}
